module.exports = __webpack_public_path__ + "img/4.4fa05c12.jpg";